import styled from '@emotion/styled';

export const NaturalPersonViewPageContentContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const NaturalPersonViewPageContentTabsArea = styled.div`
  margin-top: 32px;
  margin-left: -10px;
`;

export const NaturalPersonViewPageContentHeaderButtons = styled.section`
  display: flex;
  button {
    width: auto;
    margin-right: 16px;
  }
`;
